export enum CouponCodeIcons {
    checkMarkIcon = 'wix:vector://v1/11062b_6fb5be62b32843b686a05463fa8f752d.svg/',
  }